"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef, Component } from "react";
import classNames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { TreebeardHeader } from "./TreebeardHeader";
import { TransitionGroup, Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import { ChevronRight } from "../../icons";
import * as styles from "./TreebeardDecorators-css";
var FOLDER_HEIGHT = 48;
var Container = /*#__PURE__*/function (_Component) {
  _inherits(Container, _Component);
  var _super = _createSuper(Container);
  function Container(props) {
    var _this;
    _classCallCheck(this, Container);
    _this = _super.call(this, props);
    _this.containerTop = 0;
    _this.treeParentTop = 0;
    _this.containerRef = createRef();
    return _this;
  }
  _createClass(Container, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a, _b, _c, _d;
      var treeParentRef = this.props.node.treeParentRef;
      this.containerTop = (_b = (_a = this.containerRef.current) == null ? void 0 : _a.getBoundingClientRect().top) != null ? _b : 0;
      this.treeParentTop = (_d = (_c = treeParentRef == null ? void 0 : treeParentRef.current) == null ? void 0 : _c.getBoundingClientRect().top) != null ? _d : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$node = this.props.node,
        isLoading = _this$props$node.isLoading,
        animationState = _this$props$node.animationState,
        children = _this$props$node.children;
      var isTerminal = children.length === 0;
      var renderContent = function renderContent(status) {
        var showLoadng = isLoading && status !== "entered";
        var transform = showLoadng ? "translate3d(0, -".concat(_this2.containerTop - _this2.treeParentTop - FOLDER_HEIGHT, "px, 0)") : void 0;
        return /* @__PURE__ */React.createElement("div", {
          className: classNames(styles.content({
            visible: !!status && ["entering", "entered"].includes(status),
            loading: isLoading
          })),
          style: {
            transform: transform
          }
        }, isTerminal ? /* @__PURE__ */React.createElement("div", {
          className: styles.toggle()
        }) : /* @__PURE__ */React.createElement(Toggle, __spreadValues({}, _this2.props)), /* @__PURE__ */React.createElement(TreebeardHeader, __spreadValues({}, _this2.props)));
      };
      return /* @__PURE__ */React.createElement("div", {
        className: "treebeard-container",
        ref: this.containerRef
      }, /* @__PURE__ */React.createElement(TransitionGroup, {
        component: null
      }, !!animationState && animationState === "visible" && this.containerTop !== void 0 && /* @__PURE__ */React.createElement(Transition, {
        appear: true,
        timeout: 400,
        onEnter: forceReflow
      }, function (status) {
        return renderContent(status);
      })), !animationState && renderContent("entered"));
    }
  }]);
  return Container;
}(Component);
__decorateClass([observable.ref], Container.prototype, "containerTop", 2);
__decorateClass([observable.ref], Container.prototype, "treeParentTop", 2);
Container = __decorateClass([observer], Container);
function Toggle(props) {
  var onClick = props.onClick,
    _props$node = props.node,
    toggled = _props$node.toggled,
    id = _props$node.id;
  return /* @__PURE__ */React.createElement("button", {
    className: styles.toggle({
      expanded: toggled
    }),
    onClick: onClick,
    "aria-expanded": toggled,
    "aria-labelledby": "tree-".concat(id, "-folder"),
    id: "tree-".concat(id, "-toggle")
  }, /* @__PURE__ */React.createElement(ChevronRight, {
    color: "default"
  }));
}
export var customDecorators = {
  Toggle: Toggle,
  Header: TreebeardHeader,
  Container: Container
};
export var customTheme = {
  tree: {
    base: {
      background: "transparent"
    }
  }
};